const headerTitle = {
  type: 'Heading',
  name: 'A1',
  fontWeight: '850',
  letter: 'normal',
  fontSize: '14px',
  lineHeight: '21px'
}

const desktopHeaderTitle = {
  type: 'Heading',
  name: 'A1',
  fontWeight: '850',
  letter: 'normal',
  fontSize: '14px',
  lineHeight: '21px',
}

const headerDescription = {
  type: 'Label',
  name: '1',
  fontWeight: '400',
  letter: '0.21px',
  fontSize: '14px',
  lineHeight: '17.5px',
  desktopFontSize: '12px',
  desktopLineHeight: '15px',
}

const contentDescription = {
  type: 'Label',
  name: '3',
  fontWeight: '325',
  letter: '0.18px',
  fontSize: '12px',
  lineHeight: '15px',
  desktopFontSize: '12px',
  desktopLineHeight: '15px'
}

const benefitCardTitle = {
  type: 'Heading',
  name: 'A2',
  fontWeight: '850',
  letter: 'normal',
  fontSize: '12px',
  lineHeight: '16px',
  desktopFontSize: '12px',
  desktopLineHeight: '16px'
}

const benefitCardDescription = {
  type: 'Paragraph',
  name: '3',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '21px',
  desktopFontSize: '14px',
  desktopLineHeight: '21px'
}

export default {
  headerTitle,
  headerDescription,
  contentDescription,
  benefitCardTitle,
  benefitCardDescription,
  desktopHeaderTitle
}
